import { Injectable } from '@angular/core';
import { Observable, of, map, catchError, tap } from 'rxjs';
import { StateCountService } from './API/state-count.service'; // Adjust path as needed
import { PropertyCountService } from './API/property-count.service'; // Adjust path as needed
import { StateRowCount } from '../../models/state-row-count.model'; // Adjust path as needed
import { BACKEND_KEY_TO_UI_LABEL_MAP, COMPANY_PROPERTIES_CONFIG, STATES_PROPERTIES_CONFIG } from '../../ProductSearch/ListConfiguration/InfoConverstion';

// move these interfaces to shared models files
export interface StateRow { label: string; count: number; }
export interface CompanyInfoRow { label: string; count: number; category: string; }
export interface PropertyCount {
    property: string;
    rows: number;
}
@Injectable({
    providedIn: 'root'
})
export class ListConfiguratorService {
    states: StateRow[] = STATES_PROPERTIES_CONFIG.map(prop => ({
        label: prop.label,
        count: 0,
    }));

    companyInfos: CompanyInfoRow[] = COMPANY_PROPERTIES_CONFIG.map(prop => ({
        label: prop.label,
        count: 0,
        category: prop.category,
    }));

    constructor(
        private stateCountService: StateCountService,
        private propertyCountService: PropertyCountService,
    ) {}

    /**
     * Loads state counts for a given table and updates the local states array.
     * @param tableName The name of the table (e.g., industry).
     */
    loadStateCounts(tableName: string): void {
        this.stateCountService.getStateCounts(tableName)
            .pipe(
                catchError(err => {
                    console.error('Error loading state-counts:', err);
                    return of([] as StateRowCount[]);
                })
            )
            .subscribe(counts => {
                const lookup = new Map<string, number>();
                counts.forEach(item => lookup.set(item.state, item.rows));

                this.states.forEach(sr => {
                    if (sr.label === this.states[0].label) { // 'Deutschlandweit'
                        sr.count = lookup.get('TOTAL') ?? 0;
                    } else {
                        sr.count = lookup.get(sr.label) ?? 0;
                    }
                });
            });
    }

    /**
     * Fetches property counts for selected states and updates the companyInfos array.
     *
     * @param tableName The selected table (industry).
     * @param states The currently selected states.
     */
    getPropertyCount(tableName: string, states: string[]): void {
        this.propertyCountService
            .getPropertyCounts(tableName, states)
            .pipe(
                tap(counts => console.log(`Counts for ${states}:`, counts)),
                catchError(err => {
                    console.error(`Error fetching counts for ${states}:`, err);
                    return of([] as PropertyCount[]);
                })
            )
            .subscribe(apiCounts => {
                const countsByLabel = new Map<string, number>();
                apiCounts.forEach(apiCount => {
                    const uiLabel = BACKEND_KEY_TO_UI_LABEL_MAP[apiCount.property];
                    if (uiLabel) {
                        countsByLabel.set(uiLabel, apiCount.rows);
                    } else {
                        console.warn(`Backend property '${apiCount.property}' not found in mapping.`);
                    }
                });

                this.companyInfos.forEach(infoRow => {
                    infoRow.count = countsByLabel.get(infoRow.label) ?? 0;
                });
            });
    }
}